<template>
    <div class="row">
        <div class="col-12" v-if="$store.state.authentication.status.loggedIn">
            <b-navbar toggleable="lg">
                <b-navbar-brand v-on:click="$router.push('/')">
                    <!--<img id="branding" src="../assets/img/logo-white.svg"/>-->
                </b-navbar-brand>
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item v-on:click="backToOld('/')" right>{{ $t('navbar.label.home') }}</b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </div>
    </div>
</template>

<script>
    import {accountService} from "@/_services";

    export default {
        name: 'navbar',
        data: () => {
            return {
                password_new: '',
                password_repeat: '',
                password_length: 0,
                contains_eight_characters: false,
                contains_number: false,
                contains_uppercase: false,
                contains_special_character: false,
                password_match: false,
                valid_password: false,
                password_result: 'waiting'
            }
        },
        mounted() {
            /*if(this.$store.state.authentication.status.loggedIn) {
                authService.refresh()
            }*/
        },
        methods: {
            backToOld(path) {
                window.location.href = path;
            },
            changePassword(e) {
                if(this.valid_password) {
                    accountService.changePassword(this.password_new).then(() => {
                        this.password_result = 'ok';
                        this.$bvModal.show('password_result_modal');
                        this.password_new = '';
                        this.password_repeat = '';
                        this.checkPassword();
                    })
                } else {
                    e.preventDefault();
                    this.password_result = 'badrequirements';
                    this.$bvModal.show('password_result_modal');
                }

            },
            checkPassword() {
                this.password_length = this.password_new.length;
                const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

                if (this.password_length > 8) {
                    this.contains_eight_characters = true;
                } else {
                    this.contains_eight_characters = false;
                }

                this.contains_number = /\d/.test(this.password_new);
                this.contains_uppercase = /[A-Z]/.test(this.password_new);
                this.contains_special_character = format.test(this.password_new);
                this.password_match = this.password_new.length > 0 && (this.password_new === this.password_repeat);

                if (this.contains_eight_characters === true &&
                    this.contains_special_character === true &&
                    this.contains_uppercase === true &&
                    this.password_match === true &&
                    this.contains_number === true) {
                    this.valid_password = true;
                } else {
                    this.valid_password = false;
                }
            }
        }
    }
</script>

<style>
    ul.pass_list {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .pass_check {
        margin-bottom: 8px;
        position: relative;
    }
    .pass_check:before {
        content: "";
        width: 0%; height: 2px;
        background: #2ecc71;
        position: absolute;
        left: 0; top: 50%;
        display: block;
        transition: all .6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
    .is_valid { color: rgba(136, 152, 170, 0.8); }
    .is_valid:before { width: 100%; }

    @keyframes draw {
        to { stroke-dashoffset: 0; }
    }
</style>